import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { AbstractDialogComponent } from '../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { FormFieldModel } from './form-field.model';

export class StaticTextHeadingFieldActionModel {
    icon: string;
    tooltip: string;
    panel: Type<AbstractDialogComponent>;
}

export class StaticTextHeadingFieldModel implements FormFieldModel {
    property = ''; // there's no relevant property - 'null' throws errors.

    fieldComponent: Type<AbstractFormFieldComponent>;
    heading: string;
    id: string;
    appearCondition?: (x: any) => boolean;
    // Optional icon button rendered next to the heading, opening the given takeover panel (e.g. a "manage" shortcut).
    action?: StaticTextHeadingFieldActionModel;

    constructor(
        type: Type<AbstractFormFieldComponent>,
        heading: string,
        id: string = '',
        appearCondition?: (x: any) => boolean,
        action?: StaticTextHeadingFieldActionModel
    ) {
        this.fieldComponent = type;
        this.heading = heading;
        this.id = id;
        this.appearCondition = appearCondition;
        this.action = action;
    }
}
